// src/components/LanguageSwitcher.jsx
import { useTranslation } from 'react-i18next';
import styles from '../styles/LanguageSwitcher.module.css';

export default function LanguageSwitcher({ variant = 'light' }) {
  const { i18n } = useTranslation();
  const currentLang = (i18n.language || 'en').split('-')[0].toLowerCase();

  const handleLangChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  const isDark = variant === 'dark';

  return (
    <div className={`${styles.container} ${isDark ? styles.darkContainer : ''}`} aria-label="Language selector">
      <button
        type="button"
        className={`${styles.btn} ${currentLang === 'en' ? styles.active : ''}`}
        onClick={() => handleLangChange('en')}
        title="English"
      >
        EN
      </button>
      <button
        type="button"
        className={`${styles.btn} ${currentLang === 'fr' ? styles.active : ''}`}
        onClick={() => handleLangChange('fr')}
        title="Français"
      >
        FR
      </button>
    </div>
  );
}
